import { useEffect, useState } from 'react';
import { useRouter } from '@abyss/web/hooks/useRouter';
import { UserService } from '@src/api/common/UserService';
import { logoutFromMicrosoft } from '@src/api/common/MsalService';

const DOCUMENTATION_URL = 'https://abyss.uhc.com/';

const HeaderController = () => {
  const { navigate } = useRouter();
  const [msid, setMsid] = useState('MSID');

  const Action = {
    Logout: async () => {
      // Clears local auth state and lands on the login screen without destroying the SSO session.
      // MarkSkipAutoSsoOnce prevents the login page from auto-redirecting back into the app via silent SSO.
      // To fully log out of Microsoft SSO instead, restore: await logoutFromMicrosoft();
      UserService.ClearSession(false);
      UserService.MarkSkipAutoSsoOnce();
      navigate('/login');
    },
    OpenDocumentation: () => {
      window.open(DOCUMENTATION_URL, '_blank', 'noopener,noreferrer');
    },
  };

  useEffect(() => {
    const user = UserService.GetUser();
    if (user) {
      setMsid(
          user.userName ||
          user.displayName ||
          user.emailAddress ||
          user.givenName ||
          user.initials ||
          'MSID'
      );
    }
  }, []);

  return [
    {
      msid,
      Action,
    },
  ];
};

export { HeaderController };
